// Fall Guys-style soft edges. `SoftBox` is a drop-in replacement for
// `THREE.BoxGeometry` (same constructor signature) that produces a rounded
// box with auto-scaled bevel.
import * as THREE from "three";
import { RoundedBoxGeometry } from "three/examples/jsm/geometries/RoundedBoxGeometry.js";

export class SoftBox extends RoundedBoxGeometry {
  constructor(width = 1, height = 1, depth = 1, _segX?: number, _segY?: number, _segZ?: number) {
    const minDim = Math.max(0.001, Math.min(width, height, depth));
    // Round ~14% of the smallest side, capped so it never looks like a sphere
    // and never adds more than 0.18 world units of bevel.
    const radius = Math.min(minDim * 0.14, 0.18, minDim * 0.45);
    super(width, height, depth, 3, radius);
  }
}

// Preserve original alias for any internal code that may need a true box.
export const HardBox = THREE.BoxGeometry;
